<div class=" jumbotron-fluid bg-transparent m-1 pb-1 row" *ngIf="!responsiveService.isMobile && showSteps">
  <div class="col-12 d-flex justify-content-between px-5">
    <h2 class="color-primary mb-0"> {{ ubicacion }}</h2>
  </div>

  <div class="col-12 step-layout" *ngIf="footer">
    <div class="col-12 col-md-5 col-xl-6 offset-md-2 d-flex step-items">
      <ng-template ngFor let-item [ngForOf]="steps" let-i="index">
        <div class="col-2">
          <span *ngIf="locked" class="nav-link disabled">
            <img [src]="stepImage(i+1, item.active, item.title)" alt="paso{{item.url}}" class="icon-footer">
          </span>
          <a *ngIf="!locked" routerLink="{{item.url}}" class="nav-link" routerLinkActive="active" [class.disabled]="disabledLink(i)">
            <img [src]="stepImage(i+1, item.active, item.title)" alt="paso{{item.url}}" class="icon-footer">
          </a>
        </div>
      </ng-template>
    </div>

    @if(ubicacion == 'Escoge tu proyecto' && !isCementoFlow){
     <div *ngIf="ubicacion == 'Escoge tu proyecto'" class="step-know-product-shell">
      <strong class="step-know-product-cta">
        <h5 class="step-know-product-text">Si conoces tu producto</h5>
        <button class="btn btn-success mb-0 btn-pulse" (click)="stepKnowProduct()">
          ingresa aquí <i class="bi bi-box-arrow-in-up-right"></i>
        </button>
      </strong>
    </div>

    }
  </div>
</div>
